import axios from 'axios';

export const api = axios.create({
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    api_key: process.env.REACT_APP_ECONOMYSA_API_KEY,
  },
});
